import React from "react";
import {
  Box,
  Step,
  StepConnector,
  StepLabel,
  Stepper,
  Typography,
  stepConnectorClasses,
  styled,
} from "@mui/material";
import { Check } from "@mui/icons-material";

const steps = [
  { path: "/signup", title: "Sign Up" },
  { path: "/verify-otp", title: "Verify OTP" },
  { path: "/nin-verification", title: "NIN Verification" },
  { path: "/identity-verification", title: "Identity Verification" },
  { path: "/payment", title: "Payment" },
  { path: "/add-bank", title: "Add Bank" },
];

const ProgressConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 16,
    left: "calc(-50% + 16px)",
    right: "calc(50% + 16px)",
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: "#e4d9eb",
    borderTopWidth: 3,
    borderRadius: 2,
    transition: theme.transitions.create("border-color"),
  },
  [`&.${stepConnectorClasses.active} .${stepConnectorClasses.line}, &.${stepConnectorClasses.completed} .${stepConnectorClasses.line}`]:
    {
      borderColor: "#52057b",
    },
}));

const StepIcon = ({ active, completed, icon }) => (
  <Box
    sx={{
      width: 34,
      height: 34,
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: completed || active ? "#fff" : "#80618f",
      backgroundColor: completed ? "#52057b" : active ? "#52057b" : "#f1ebf4",
      border: active && !completed ? "3px solid #d9bce6" : "none",
      boxSizing: "border-box",
      fontSize: "0.85rem",
      fontWeight: 800,
      boxShadow: active ? "0 0 0 4px rgba(82, 5, 123, 0.08)" : "none",
    }}
  >
    {completed ? <Check sx={{ fontSize: 21 }} /> : icon}
  </Box>
);

const OnboardingStepper = ({ activePath }) => {
  const activeStep = steps.findIndex((step) => step.path === activePath);

  return (
    <Box
      component="nav"
      aria-label="Onboarding progress"
      sx={{
        width: "100%",
        backgroundColor: "#fff",
        borderBottom: "1px solid #eee7f1",
        px: { xs: 1, sm: 3, md: 6 },
        py: { xs: 2, sm: 2.5 },
        boxSizing: "border-box",
      }}
    >
      <Stepper
        activeStep={activeStep}
        alternativeLabel
        connector={<ProgressConnector />}
        sx={{ maxWidth: 980, mx: "auto" }}
      >
        {steps.map((step, index) => (
          <Step key={step.path} completed={index < activeStep}>
            <StepLabel
              StepIconComponent={(props) => <StepIcon {...props} />}
              sx={{
                "& .MuiStepLabel-label": {
                  mt: 1,
                  color: "#80618f",
                  fontSize: { xs: "0.62rem", sm: "0.78rem" },
                  fontWeight: 600,
                  lineHeight: 1.2,
                },
                "& .MuiStepLabel-label.Mui-active, & .MuiStepLabel-label.Mui-completed":
                  {
                    color: "#52057b",
                    fontWeight: 800,
                  },
              }}
            >
              <Typography component="span">{step.title}</Typography>
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};

export { steps };
export default OnboardingStepper;
